export { default } from './add-to-wishlist-anchor';